<vertical-divider class="divider--left"></vertical-divider>

<avatar [userName]="userName"></avatar>

<div class="user-info__container">
  <div *ngIf="(userInfo$ | async)?.user" class="user-info__name">
    <span data-e2e="user-info-fragment__name">{{ userName }}</span>
  </div>
</div>

<vertical-divider class="divider--right"></vertical-divider>
